// extracted by mini-css-extract-plugin
module.exports = {"error-container":"Error_error-container__1CjoX","text-container":"Error_text-container__-FvQ4"};